module.exports = __webpack_public_path__ + "img/wk-product-4-2x.0466dffa.png";